import { Component, Input } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';

@Component({
  selector: 'app-area-image-component',
  templateUrl: './areaImage.component.html',
  styleUrls: ['./areaImage.component.scss'],
  animations: [
    trigger('fullSizeImageVisibility', [
      state('visible', style({
        opacity: 1,
        visibility: 'visible',
      })),
      state('hidden',   style({
        opacity: 0,
        visibility: 'hidden',
      })),
      transition('visible <=> hidden', animate('100ms ease-in')),
    ]),
  ],
})
export class AreaImageComponent {
  @Input() src: string;
  fullSizeImageVisibilityState = 'hidden';

  showFullSizeImage(): void {
    this.fullSizeImageVisibilityState = 'visible';
  }

  hideFullSizeImage(): void {
    this.fullSizeImageVisibilityState = 'hidden';
  }
}



// WEBPACK FOOTER //
// ./src/app/common/components/AreaImageComponent/areaImage.component.ts